import { Suspense, lazy, useEffect, useRef, useState } from "react";

const defaultFallback = <div className="min-h-[120px]" aria-hidden="true" />;

export default function LazySection({
  loader,
  fallback = defaultFallback,
  rootMargin = "300px 0px",
}) {
  const containerRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);
  const [LazyComponent, setLazyComponent] = useState(null);

  useEffect(() => {
    const node = containerRef.current;

    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          return;
        }

        setShouldRender(true);
        observer.disconnect();
      },
      { rootMargin }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [rootMargin]);

  useEffect(() => {
    if (!shouldRender || LazyComponent) {
      return;
    }

    setLazyComponent(() => lazy(loader));
  }, [LazyComponent, loader, shouldRender]);

  return (
    <div
      ref={containerRef}
      style={{
        contentVisibility: "auto",
        containIntrinsicSize: "1px 600px",
      }}
    >
      {LazyComponent ? (
        <Suspense fallback={fallback}>
          <LazyComponent />
        </Suspense>
      ) : (
        fallback
      )}
    </div>
  );
}
